import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoleType } from '@enums/role-type.enums';
import { OverlayComponent } from '@overlays/overlay/overlay.component';
import { DomainRole } from '@services/genesys-cloud-user.interface';
import { isDefaultAdmin, isDeveloper, isOutboundAdmin, isSystemAdmin, isWEMAdmin } from '@utils/role-type.utils';
import { NgStyle } from '@angular/common';
import { EducationCourseListComponent } from '../../lists/education-course-list/education-course-list.component';

@Component({
  selector: 'app-education-overlay',
  templateUrl: './education-overlay.component.html',
  styleUrls: ['./education-overlay.component.scss'],
  imports: [NgStyle, EducationCourseListComponent],
})
export class EducationOverlayComponent extends OverlayComponent {
  @Input() role: DomainRole;
  @Output() readonly linkClick = new EventEmitter<boolean>();

  /**
   * Show WEM users as generic WEM Administrators. Admin users as Administrators.
   * Everyone else will show Developer.
   */
  getRoleDisplayName(): string {
    if (!this.role?.name) {
      return '';
    }

    if (isWEMAdmin(this.role.name)) {
      return `WEM ${RoleType.ADMINISTRATOR.toLowerCase()}s`;
    } else if (isOutboundAdmin(this.role.name)) {
      return `${RoleType.OUTBOUND_ADMIN.toLowerCase()}s`;
    } else if (isDefaultAdmin(this.role.name)) {
      return `${RoleType.ADMINISTRATOR.toLowerCase()}s`;
    } else if (isSystemAdmin(this.role.name)) {
      return `${RoleType.SYSTEM_ADMINISTRATOR.toLowerCase()}s`;
    } else if (isDeveloper(this.role.name)) {
      return `${RoleType.DEVELOPER.toLowerCase()}s`;
    } else {
      // Unassigned roles defaults to an employee for a given organization
      return `${RoleType.EMPLOYEE.toLowerCase()}s`;
    }
  }

  /**
   * Domain Role Type Enum
   * @returns {typeof RoleType}
   */
  public get roleType(): typeof RoleType {
    return RoleType;
  }

  /**
   * Emit link click event to parent
   */
  override onLinkClick(): void {
    console.log('Education Course Link clicked');
    this.linkClick.emit(true);
  }

  /**
   * Update the overlay styles based on the viewport size
   */
  override updateOverlayStyles(): void {
    const { playerWidth = 0, playerHeight = 0, browserHeight = 0, browserWidth = 0 } = this.viewportSize || {};

    // Calculate dimensions and position
    let overlayWidth: number | string;
    let leftPosition: number | string;
    let topPosition: number | string;
    let calcHeight: number | string;
    let calcPadding: number | string;
    let calcFontSize: number | string;

    // NOTE: Check if browser height is really big or when the
    // browser winodw is narrow. Adjust the overlay to mat
    // the smaller player height and widths.
    if (browserHeight > browserWidth) {
      overlayWidth = Math.floor(playerWidth * 0.75);
      leftPosition = Math.floor((browserWidth - overlayWidth) * 0.333);
      topPosition = Math.floor(playerHeight * 0.35);
      calcHeight = 'fit-content';
      calcFontSize = `3vw`;
      calcPadding = `2vh`;
    } else {
      overlayWidth = Math.floor(browserWidth * 0.85);
      leftPosition = Math.floor((browserWidth - overlayWidth) * 0.444);
      topPosition = Math.floor(playerHeight * 0.35);
      calcHeight = 'fit-content';
      calcFontSize = `3vw`;
      calcPadding = `2vh`;
    }

    this.overlayStyles = {
      position: 'absolute',
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
      width: `${overlayWidth}px`,
      fontSize: calcFontSize,
      height: `${calcHeight}`,
      padding: `${calcPadding}`,
    };
  }
}
